import React from 'react';
import { Users, Calendar } from 'lucide-react';

const OwnershipSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Users className="w-5 h-5 mr-2 text-indigo-500" />
        Информация о владении
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Доля в собственности */}
        <div>
          <label htmlFor="ownershipShare" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Доля в собственности
          </label>
          <div className="flex items-center">
            <input
              type="text"
              id="ownershipShare"
              name="ownershipShare"
              value={formData.ownershipShare}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.ownershipShare ? 'input-error' : ''}`}
              placeholder="Введите долю (от 0 до 1)"
            />
            <span className="ml-2 text-gray-600 dark:text-gray-400">
              {(parseFloat(formData.ownershipShare) * 100 || 0).toFixed(0)}%
            </span>
          </div>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Укажите долю от 0 до 1 (например, 0.5 = 50%)
          </p>
          {errors.ownershipShare && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.ownershipShare}
            </p>
          )}
        </div>

        {/* Период владения */}
        <div>
          <label htmlFor="ownershipDuration" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Calendar className="w-4 h-4 mr-2 text-indigo-500" />
            Период владения в налоговом периоде
          </label>
          <div className="flex items-center">
            <input
              type="number"
              id="ownershipDuration"
              name="ownershipDuration"
              value={formData.ownershipDuration}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.ownershipDuration ? 'input-error' : ''}`}
              placeholder="Количество месяцев"
              min="0"
              max="12"
            />
            <span className="ml-2 text-gray-600 dark:text-gray-400">мес.</span>
          </div>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Укажите количество полных месяцев владения объектом в течение налогового периода
          </p>
          {errors.ownershipDuration && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.ownershipDuration}
            </p>
          )}
        </div>
      </div>

      {/* Подсказка о долевой собственности */}
      <div className="mt-4 bg-yellow-50 dark:bg-yellow-900/20 p-3 rounded-lg border border-yellow-200 dark:border-yellow-800">
        <div className="flex items-start">
          <Users className="w-5 h-5 text-yellow-600 dark:text-yellow-400 mr-3 mt-0.5" />
          <div>
            <h4 className="text-sm font-medium text-yellow-700 dark:text-yellow-300 mb-1">
              Важно о долевой собственности
            </h4>
            <p className="text-xs text-yellow-600 dark:text-yellow-400">
              Если объект находится в долевой собственности, каждый собственник платит налог пропорционально своей доле.
              При совместной собственности налог обычно распределяется равными частями между собственниками.
            </p>
          </div>
        </div>
      </div>
      
      {/* Подсказка о периоде владения */}
      <div className="mt-3 bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
        <div className="flex items-start">
          <Calendar className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-0.5" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Расчет периода владения
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Налог рассчитывается за полные месяцы владения. Если право собственности возникло до 15 числа месяца включительно или прекратилось после 15 числа, месяц принимается за полный.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OwnershipSection;